import { IRoleAllLang } from '../../../types/lang'
import { roleCrudModalLang } from './roleCrudModal'
import { rolePageLang } from './rolePage'
import { roleListTableLang } from './roleListTable'
import { roleAccessRuleLang } from './roleAccessRule'

export const roleAllLang: IRoleAllLang = {
	...rolePageLang,
	...roleCrudModalLang,
	...roleListTableLang,
	...roleAccessRuleLang
}